import $ from 'jquery';

function ActivityView(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
  this.listen();
  this.noResults();
}

ActivityView.prototype = {
  init() {
    $(document.body).addClass('grid-view');
  },
  toggleClass() {
    $(document.body).toggleClass('grid-view');
  },
  listen() {
    this.$element.find('.block-prefix button').on('click', this.toggleClass);
  },
  noResults() {
    if (this.$element.hasClass('placeholder-block')) {
      this.$element.find('.placeholder-text span').text('No classes available at this time');
      this.$element.find('.placeholder-text').fadeIn();
    }
  },
};

export default ActivityView;
